/**
 * ISO 4217 currency codes for organization local currency (Settings).
 * Sorted by code for dropdown display.
 */
export const CURRENCY_OPTIONS = [
  { code: '', label: '— Select currency —' },
  { code: 'AED', label: 'AED — UAE Dirham' },
  { code: 'AUD', label: 'AUD — Australian Dollar' },
  { code: 'BGN', label: 'BGN — Bulgarian Lev' },
  { code: 'BRL', label: 'BRL — Brazilian Real' },
  { code: 'CAD', label: 'CAD — Canadian Dollar' },
  { code: 'CHF', label: 'CHF — Swiss Franc' },
  { code: 'CNY', label: 'CNY — Chinese Yuan' },
  { code: 'CZK', label: 'CZK — Czech Koruna' },
  { code: 'DKK', label: 'DKK — Danish Krone' },
  { code: 'EUR', label: 'EUR — Euro' },
  { code: 'GBP', label: 'GBP — Pound Sterling' },
  { code: 'HKD', label: 'HKD — Hong Kong Dollar' },
  { code: 'HUF', label: 'HUF — Hungarian Forint' },
  { code: 'IDR', label: 'IDR — Indonesian Rupiah' },
  { code: 'ILS', label: 'ILS — Israeli New Shekel' },
  { code: 'INR', label: 'INR — Indian Rupee' },
  { code: 'ISK', label: 'ISK — Icelandic Króna' },
  { code: 'JPY', label: 'JPY — Japanese Yen' },
  { code: 'KRW', label: 'KRW — South Korean Won' },
  { code: 'MXN', label: 'MXN — Mexican Peso' },
  { code: 'MYR', label: 'MYR — Malaysian Ringgit' },
  { code: 'NOK', label: 'NOK — Norwegian Krone' },
  { code: 'NZD', label: 'NZD — New Zealand Dollar' },
  { code: 'PHP', label: 'PHP — Philippine Peso' },
  { code: 'PLN', label: 'PLN — Polish Złoty' },
  { code: 'RON', label: 'RON — Romanian Leu' },
  { code: 'RUB', label: 'RUB — Russian Ruble' },
  { code: 'SAR', label: 'SAR — Saudi Riyal' },
  { code: 'SEK', label: 'SEK — Swedish Krona' },
  { code: 'SGD', label: 'SGD — Singapore Dollar' },
  { code: 'THB', label: 'THB — Thai Baht' },
  { code: 'TRY', label: 'TRY — Turkish Lira' },
  { code: 'USD', label: 'USD — US Dollar' },
  { code: 'ZAR', label: 'ZAR — South African Rand' },
];

/** @param {unknown} raw */
export function normalizeCurrencyCode(raw) {
  const s = String(raw ?? '').trim().toUpperCase();
  if (!/^[A-Z]{3}$/.test(s)) return null;
  return s;
}
